// extracted by mini-css-extract-plugin
module.exports = {"mainLayout":"styles_mainLayout__ykiXo"};